module.exports = __webpack_public_path__ + "img/no-collections.6ec267f9.svg";